import { t } from "@/i18n-js/instance";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const DiscountLine = () => {
  const { previewMutation } = usePaywallCheckoutContext();

  const preview = previewMutation.data;

  if (!preview || previewMutation.isLoading) {
    return <SkeletonLoader variant="row" lg />;
  }

  if (!preview || preview.first_payment.discount >= 0) {
    return null;
  }

  const formattedDiscountText =
    preview.first_payment.formatted_discount.replaceAll("-", "");

  return (
    <div className="text-right first:w-full first:text-right">
      <Typography.LabelXs weight="medium" color="text-green-success">
        {t("total_savings", { formatted_discount: formattedDiscountText })}
      </Typography.LabelXs>
    </div>
  );
};
